// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"r0-z","sponsoredTooltipWrapper":"s0-z","sponsoredTooltip":"t0-z","newCard":"u0-z"};